import { FC, PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router';

import { selectCurrentUser } from '@src/store/auth/auth-selectors';
import { useAppSelector } from '@src/store/store';

import paths from '@src/routes/routes';
import { RoleType } from '@src/types/main';

type RoleGuardProps = PropsWithChildren & {
  roles: RoleType[];
};

const RoleGuard: FC<RoleGuardProps> = (props) => {
  const { roles, children } = props;

  const user = useAppSelector(selectCurrentUser)!;

  const isAllowed = roles.includes(user?.role);

  const navigate = useNavigate();

  useEffect(() => {
    if (user && !isAllowed) {
      navigate(paths.page403, { replace: true });
    }
  }, [user, isAllowed, navigate]);

  if (!isAllowed) {
    return null;
  }

  return children;
};

export default RoleGuard;
